// extracted by mini-css-extract-plugin
export var alignCenter = "_bi-d";
export var bannerShown = "_bi-6";
export var buttonContent = "_bi-0";
export var cardList = "_bi-1";
export var centerContent = "_bi-2";
export var chevron = "_bi-3";
export var closePanelButton = "_bi-k";
export var conversationContextContainer = "_bi-l";
export var conversationDetailContainer = "_bi-4";
export var detailWrapper = "_bi-7";
export var dropdownButton = "_bi-e";
export var dropdownTitle = "_bi-9";
export var fullHeight = "_bi-5";
export var hidden = "_bi-a";
export var icon = "_bi-b";
export var mergeSuggestionWrapper = "_bi-m";
export var panel = "_bi-i";
export var portalButtonsWrapper = "_bi-c";
export var right = "_bi-j";
export var tableSummaryContainer = "_bi-8";
export var tableSummaryHeader = "_bi-g";
export var threeDotsButton = "_bi-f";
export var wide = "_bi-h";